<script setup lang="ts">
import { makeLink } from '../js-utils/_shared/utils';
const props = defineProps<{
    mode: 'lib' | 'html' | 'dev';
    pageName: string;
}>();
</script>

<template>
    <div class="footer">
        <div class="col">Footer</div>
        <a class="col" :href="makeLink('index', props.mode)">Índice</a>
    </div>
</template>
<style scoped lang="scss">
.footer {
    display: flex;
    justify-content: start;
    align-items: center;
    padding: 10px 20px;
    background-color: #5f656d;
    gap: 100px;
    a {
        font-weight: bold;
    }
    div {
        font-size: 1.3em;
    }
    .col {
        margin-right: 20px;
        color: white;
    }
}
</style>
